import config from "config/config";

const getChatStatus = async (portal) => {
  let options = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ClientSecret: config.PORTAL_CLIENT_SECRET,
    },
  };

  const response = await fetch(
    `${config.REG_API_BASE_URL}/chat?portal=${portal}`,
    options
  );

  if (!response.ok) {
    throw response;
  } else {
    const data = await response.json();
    return data;
  }
};

export default getChatStatus;
